import React from 'react';

import b_ from 'b_';

import ExternalLmsBadge from 'common.components/external-lms-badge/external-lms-badge';
import { useTeamName } from 'utils/get-name';

import './classes-select-team.scss';

interface Props {
    grade: number;
    isMes?: boolean;
    name: string;
}

const b = b_.with('classes-select-team');

export const ClassesSelectTeam = ({ grade, isMes, name }: Props) => {
    const teamName = useTeamName({
        grade,
        name,
        hideLabel: isMes && name.length > 3,
        hideCollegeLabel: true,
        e2eIds: { grade: 'qa_team-grade' },
        jsx: true,
    });

    return (
        <div className={b({ 'is-mes': isMes })}>
            {teamName}

            {isMes && <ExternalLmsBadge mix="classes-select-team__mes-badge" textId="class.badge.mes" />}
        </div>
    );
};
